import React from "react";
import { Link } from "react-router-dom";
import { SERVICES_LIST } from "../servicedata"; // adjust path if needed

const ServiceSidebar = () => {
  return (
    <div className="service-info-right">

      {/* Other Services */}
      <div className="other-services py-7 px-6 shadow rounded2">
        <div className="text-center bg-lightgreen rounded2 mb-5 py-3">
          <h4>Other Services</h4>
        </div>

        <ul className="list-unstyled text-success">
          {SERVICES_LIST.slice(0, 5).map((service, index) => (
            <li key={index} className="mb-3 pb-3 border-bottom">
              <Link to={service.path} className="darkgreen">
                {service.title}
              </Link>
            </li>
          ))}

          <li className="mb-3 pb-3 border-bottom">
            <Link to="/services" className="darkgreen">
              View More...
            </Link>
          </li>
        </ul>
      </div>

      {/* Quick Contact */}
      <div className="quick-contact mt-4 py-7 px-6 shadow rounded2">
        <div className="text-center bg-lightgreen rounded2 mb-5 py-3">
          <h4>Quick Contact</h4>
        </div>

        <form>
          <input
            type="text"
            placeholder="Your Name *"
            className="form-control mb-3"
          />
          <input
            type="email"
            placeholder="Your Email *"
            className="form-control mb-3"
          />
          <textarea
            rows="4"
            placeholder="Enter your message..."
            className="form-control mb-3"
          />
          <button className="btn btn2 w-100">
            Submit Now
          </button>
        </form>
      </div>

    </div>
  );
};

export default ServiceSidebar;
